import { HttpErrorResponse } from '@angular/common/http';

export const handleError = async (error: HttpErrorResponse): Promise<void> => {
  let errorMessage = 'Something went wrong';

  if (error?.error?.message) {
    if (typeof error.error.message === 'string') {
      errorMessage = error.error.message;
    } else if (Array.isArray(error.error.message)) {
      for (const message of error.error.message) {
        errorMessage = message.constraints[Object.keys(message.constraints)[0]];
        break;
      }
    }
  }

  if (error.error instanceof Blob && error.error.type === 'application/json') {
    try {
      const text = await error.error.text();
      const data = JSON.parse(text);
      errorMessage = data.message;
    } catch (parseError) {
      //do nothing
    }
  }

  alert(errorMessage);
};
